import * as loadingState from '../constants/loadingState';

export const CHECK_FACEBOOK_LOGIN = 'CHECK_FACEBOOK_LOGIN';
export const FETCH_FB_SIGNUP_USER_INFO = 'FETCH_FB_SIGNUP_USER_INFO';
export const FETCH_FB_SIGNUP_USER_INFO_SUCCESS =
  'FETCH_FB_SIGNUP_USER_INFO_SUCCESS';
export const FETCH_FB_SIGNUP_USER_INFO_FAILED =
  'FETCH_FB_SIGNUP_USER_INFO_FAILED';

export const checkFacebookLogin = countryCode => ({
  type: CHECK_FACEBOOK_LOGIN,
  payload: {
    countryCode,
  },
});

export const fetchFbSignupUserInfo = ({ fbUserId, fbAccessToken }) => ({
  type: FETCH_FB_SIGNUP_USER_INFO,
  payload: {
    fbUserId,
    fbAccessToken,
  },
});

export const fetchFbSignupUserInfoSuccess = () => ({
  type: FETCH_FB_SIGNUP_USER_INFO_SUCCESS,
});

export const fetchFbSignupUserInfoFailed = errorMessage => ({
  type: FETCH_FB_SIGNUP_USER_INFO_FAILED,
  payload: {
    errorMessage,
  },
});

const INIT_STATE = {
  errorMessage: '',
  loadingStatus: loadingState.EMPTY,
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_FB_SIGNUP_USER_INFO:
      return {
        ...state,
        loadingStatus: loadingState.LOADING,
      };
    case FETCH_FB_SIGNUP_USER_INFO_SUCCESS:
      return {
        ...state,
        loadingStatus: loadingState.READY,
      };
    case FETCH_FB_SIGNUP_USER_INFO_FAILED:
      return {
        ...state,
        loadingStatus: loadingState.ERROR,
        errorMessage: action.payload.errorMessage,
      };
    default:
      return state;
  }
};

export default reducer;

export const getLoadingStatus = state => state.facebookAuth.loadingStatus;



// WEBPACK FOOTER //
// ./app/redux/facebookAuth.js